/* Juverto — motion, navigation and responsive refinements */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     THE EDITORIAL BANDS

     Every section listed here renders the same four-part shape, and the
     SECTION HEADING PATTERN block near the bottom of this file styles it:

         <div class="prose">
           <p class="h6">eyebrow</p>
           <h2 class="h2">heading</h2>
           <p>body copy</p>
           <div class="button-group"><a class="button">link</a></div>
         </div>

     The markup already exists in every one of them -- some via
     snippets/section-header.liquid, some inline -- so the pattern adds no
     elements and changes no Liquid. It only re-weights and re-spaces what is
     already on the page.

     .shopify-section--slideshow IS DELIBERATELY ABSENT. The hero is not a
     section heading: its CTA is a real button on top of photography, and
     turning it into an underlined text link would leave the first screen of
     the site with no button on it at all.
     ============================================================ */
  /* THE CSS IS GONE FROM THIS FILE (2026-09-13). It is assets/juverto.css,
     linked at the end of <head> by layout/theme.liquid, so it applies before
     the first paint instead of after this deferred script ran. Same rules,
     same cascade position, every comment carried across -- see that file. */

  /* ============ mega menu hover bridge ============
     Inserts the strip described in THE HOVER BRIDGE block above: one
     inert span per mega-menu trigger, inside the <summary> so that
     mouseover/mouseout bubble to the <details> the theme listens on.

     The CSS keeps it display:none until [open], so a closed menu owns
     nothing. Idempotent, so re-running after a section re-render
     cannot stack duplicates.

     shopify:section:load is what covers the theme editor: editing the
     header replaces its DOM, which would otherwise drop the bridges
     and silently bring the bug back for whoever is customising. */
  function addMegaBridges(root) {
    /* .juv-mega-stub is the deferred panel's placeholder (see
       sections/header.liquid). The bridge lives in the <summary>, which is
       never replaced, so adding it against the stub covers the real panel
       when the loader swaps it in. */
    (root || document).querySelectorAll('.juv-mega, .juv-mega-stub').forEach(function (mega) {
      var details = mega.closest('details');
      if (!details) return;
      var summary = details.querySelector(':scope > summary');
      if (!summary || summary.querySelector('.juv-mega-bridge')) return;
      var bridge = document.createElement('span');
      bridge.className = 'juv-mega-bridge';
      bridge.setAttribute('aria-hidden', 'true');
      summary.appendChild(bridge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { addMegaBridges(); }, { once: true });
  } else {
    addMegaBridges();
  }
  document.addEventListener('shopify:section:load', function (e) { addMegaBridges(e.target); });

  /* ============ click the photo to open the lightbox ============ */
  document.addEventListener('click', function (e) {
    var media = e.target.closest && e.target.closest('.product-gallery__media');
    if (!media) return;
    if (e.target.closest('a,button')) return;
    var gallery = media.closest('product-gallery');
    var button = gallery && gallery.querySelector('.product-gallery__zoom-button');
    if (!button) return;
    e.preventDefault();
    button.click();
  });

  if (REDUCED || !('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.collection-card',
    '.product-item',
    '.text-with-icons__item',
    '.images-with-text-scroll__text',
    '.multiple-media-with-text__content-wrapper'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('juv-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px 18% 0px', threshold: 0 });

  function arm(root) {
    var nodes = (root || document).querySelectorAll(SELECTORS);
    var groups = new Map();
    nodes.forEach(function (n) {
      if (n.hasAttribute('data-juv-reveal')) return;
      var parent = n.parentElement;
      var i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      n.style.setProperty('--juv-d', Math.min(i, 3) * 55 + 'ms');
      n.setAttribute('data-juv-reveal', '');
      io.observe(n);
    });
  }

  function boot() { arm(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();
